import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Componants/Navbar";
import Footer from "./Componants/Footer";
import AboutUs from "./Pages/Aboutus/page";
import Contact from "./Pages/Contact/page";
import Homepage from "./Pages/Home/page";
import Freedemo from "./Pages/Freedemo/page";
import Product from "./Pages/Products/page";
import Service from "./Pages/Services/page";
import Careers from "./Pages/Careers/page";
import JobDetail from './Pages/Careers/JobDetail'; // Your dynamic JobDetail page
import Blogs from "./Pages/Blogs/page";
import BlogDetail from "./Pages/Blogs/BlogDetail"; // Your new dynamic BlogDetail page
import ScrollToTop from './Componants/ScrollTop/ScrollToTop'; // Import the ScrollToTop component
import CaseStudies from "./Pages/CaseStudies/page";
import CaseStudyDetail from "./Pages/CaseStudies/CaseStudyDetail";
import News from "./Pages/News/page";
import NewsDetail from "./Pages/News/NewsDetails";

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Place ScrollToTop here, inside Router but before Routes */}
      <Navbar />

      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/freedemo" element={<Freedemo />} />
        <Route path="/product" element={<Product/>}/>
        <Route path="/service" element={<Service/>}/>
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<Careers/>}/>
        <Route path="/careers/:id" element={<JobDetail />} /> {/* Dynamic Job Detail Route */}
        <Route path="/blog" element={<Blogs/>}/>
        <Route path="/blog/:id" element={<BlogDetail />} /> {/* Dynamic Blog Detail Route */}
        <Route path="/casestudies" element={<CaseStudies/>}/>
        <Route path="/case-studies/:id" element={<CaseStudyDetail />} />
        <Route path="/news" element={<News/>}/>
        <Route path="/news/:id" element={<NewsDetail />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
